import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Switch,
  Upload,
  UploadProps,
  message,
} from "antd";
import { VideoListStore } from "../../../store";
import { InboxOutlined, UploadOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import dictionary from "../../../utils/dictionary";

function UpdateOrAdd() {
  const form = Form.useFormInstance();
  const { Option } = Select;
  const { TextArea } = Input;

  const getFormData = (changeValue?: any, allValues?: any) => {
    allValues.no = VideoListStore.lookPower.no;
    VideoListStore.setLookPower({ ...allValues, ...changeValue });
  };
  const submitPower = () => {
    console.log(JSON.parse(JSON.stringify(VideoListStore.lookPower)));
    console.log(VideoListStore.addOrUpdateModal);
    if (VideoListStore.addOrUpdateModal.upload) {//视频上传弹框
      if (VideoListStore.lookPower.upload) {
        VideoListStore.uploadVideo(
          VideoListStore.lookPower.videoTag,
          VideoListStore.formData
        );
      }
    } else  if (VideoListStore.addOrUpdateModal.uploadTest) {//视频上传test
      if (VideoListStore.lookPower.upload) {
        VideoListStore.newUploadVideo(
            VideoListStore.lookPower.priority,
            VideoListStore.lookPower.videoTag,
            VideoListStore.formData,
        );
      }
    } else if (VideoListStore.addOrUpdateModal.update) {//编辑弹框
      console.log(VideoListStore.lookPower.name,/^[A-Za-z0-9_]+$/.test(VideoListStore.lookPower.name));
      if (VideoListStore.lookPower.name) {
        if(/^[A-Za-z0-9_]+$/.test(VideoListStore.lookPower.name)){
          VideoListStore.updateVideoTag(VideoListStore.lookPower);
        }else{
          message.error('名称只能包含字母、数字及下划线');
        }
      }
    } else {
      //UserGroupStore.saveUserGroup(UserAccountStore.lookPower);
    }
  };

  const updateProps: UploadProps = {
    beforeUpload(info) {
      console.log(info);
      //格式只能为MP4
      if (info.type !== "video/mp4") {
        message.error("请上传MP4格式");
        return Upload.LIST_IGNORE;
      }
      // 名称只能包含英文、数字及下划线
      if (!/^[A-Za-z0-9_]+$/.test(info.name.substring(0, info.name.length - 4))) {
        message.error('名称只能包含字母、数字及下划线');
        return Upload.LIST_IGNORE;
      }
      // 设置上传文件大小小于75M
      const isLt50M = info.size / 1024 / 1024 < 75;
      if (!isLt50M) {
        message.error("文件不允许超过75M！");
        return Upload.LIST_IGNORE;
      }

      //时长不超过5分钟
      return new Promise((resolve) => {
        const video = document.createElement("video");
        video.preload = "metadata";
        video.onloadedmetadata = () => {
          window.URL.revokeObjectURL(video.src);
          const duration = video.duration;
          if (duration > 301) {
            // 限制时长为300秒
            message.error("视频时长不允许超过5分钟！");
            resolve(Upload.LIST_IGNORE);
          } else {
            resolve(false);
          }
        };
        video.src = URL.createObjectURL(info);
      });
    },
    onChange: (info) => {
      console.log(info);
      if (
        info.file &&
        info.file.type === "video/mp4" &&
        info.fileList.length > 0
      ) {
        VideoListStore.formData = info;
        VideoListStore.approval = true;
        message.success("上传成功");
      } else {
        VideoListStore.formData = null;
        VideoListStore.approval = false;
      }
    },
  };

  return (
    <Fragment>
      <Modal
        width={"520px"}
        centered
        title={VideoListStore.addOrUpdateModal.title}
        open={VideoListStore.addOrUpdateModal.isOpen}
        destroyOnClose={true}
        onCancel={() => VideoListStore.addOrUpdateModal.close()}
        footer={null}
      >
        {
          <Form
            form={form}
            labelCol={{ flex: "110px" }}
            labelWrap
            initialValues={VideoListStore.lookPower}
            wrapperCol={{ flex: 1 }}
            onValuesChange={getFormData}
            style={{marginTop:'20px'}}
          >
            {(VideoListStore.addOrUpdateModal.upload||VideoListStore.addOrUpdateModal.uploadTest) && (
              <Form.Item label="视频标签" name="videoTag">
                <Select placeholder="请选择视频标签" style={{ width: "330px" }}>
                  {Object.keys(dictionary.videoTag).map((key) => (
                    <Option key={key} value={dictionary.videoTag[key]}>
                      {dictionary.videoTag[key]}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {(VideoListStore.addOrUpdateModal.uploadTest) && (
                <Form.Item label="优先级" name="priority">
                  <Select placeholder="请选择视频标签" style={{ width: "330px" }} options={dictionary.priority}/>
                </Form.Item>
            )}
            {(VideoListStore.addOrUpdateModal.upload||VideoListStore.addOrUpdateModal.uploadTest) && (
              <Form.Item
                label="上传视频文件"
                name="upload"
                rules={[{ required: true, message: "请上传视频文件" }]}
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) {
                    return e;
                  }
                  return e && e.fileList;
                }}
              >
                  <Dragger {...updateProps} maxCount={1} style={{ width: "330px" }}>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      单击或拖动文件到此区域进行上传
                    </p>
                  </Dragger>
              </Form.Item>
            )}
            {VideoListStore.addOrUpdateModal.update && (
              <Form.Item
                label="视频标签"
                name="videoTag"
              >
                <Select placeholder="请选择视频标签" style={{ width: "330px" }}>
                  {Object.keys(dictionary.videoTag).map((key) => (
                    <Option key={key} value={dictionary.videoTag[key]}>
                      {dictionary.videoTag[key]}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {VideoListStore.addOrUpdateModal.update && (
              <Form.Item
                label="视频名称"
                name="name"
                rules={[{ required: true, message: "请填写视频名称" }]}
              >
                <Input placeholder="请输入视频名称" style={{ width: "330px" }}/>
              </Form.Item>
            )}
            {/* {VideoListStore.addOrUpdateModal.upload && (
              <Form.Item
                label="视频分享失败发送短信"
                name="switch"
                valuePropName="checked"
              >
                <Switch onChange={(checked)=>VideoListStore.onChangeMessage(checked)}/>
              </Form.Item>
            )} */}
            {/* {VideoListStore.addOrUpdateModal.upload && (
              <Form.Item label="短信模版" name="failMessage">
                <TextArea disabled={!VideoListStore.messageTemplate} rows={4} />
              </Form.Item>
            )}
            {VideoListStore.addOrUpdateModal.message && (
              <Form.Item
                label="挂机短信"
                name="displayName"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            )} */}
            {/* {VideoListStore.addOrUpdateModal.message && (
              <Form.Item
                label="短信模版"
                name="displayName"
                rules={[{ required: true, message: "请填写挂机短信内容" }]}
              >
                <TextArea rows={4} />
              </Form.Item>
            )} */}
            <Form.Item
              style={{ textAlign: "right" }}
              wrapperCol={{ span: 18, offset: 6 }}
            >
              <Space>
                <Button
                  htmlType="reset"
                  onClick={() => VideoListStore.addOrUpdateModal.close()}
                >
                  取消
                </Button>
                <Button type="primary" htmlType="submit" onClick={submitPower}>
                  确定
                </Button>
              </Space>
            </Form.Item>
          </Form>
        }
      </Modal>
    </Fragment>
  );
}

export default observer(UpdateOrAdd);
